const URL_PATH_REG = /^.*[\\/]/;

export function getFilename(url: string): string {
  return url.replace(URL_PATH_REG, "");
}

export function formatBytes(bytes: number): string {
  const sizes = ["Bytes", "KB", "MB"];
  if (bytes === 0) return "0 Bytes";
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
}
